<ng-container *ngIf="this.cmsNews && this.isLoaded">
  <div class="news-wrapper">
    <div class="container">
      <c-page [page]="this.cmsNews"></c-page>
      <div class="news-cta__container" *ngIf="!isNetworkSite && !hasMultipleStores">
        <a [routerLink]="'/contatti'" class="news-cta__button custom-btn btn btn--brand-color-03">
          Contattaci
        </a>
      </div>
      <div class="news-cta__container" *ngIf="isNetworkSite || (hasMultipleStores && !hasCnd)">
        <a [routerLink]=" hasCnd ? '/conad' : '/cerca-agenzia'" class="news-cta__button custom-btn btn btn--brand-color-03">
          Cerca l'agenzia più vicina a te
        </a>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!this.cmsNews && this.isLoaded">
  <div class="card-news">
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="card card-news-detail mb-3">
            <img *ngIf="!((news$ | async)?.url)" [src]="(news$ | async)?.image"
              class="card-img-top card-news-detail__img" [alt]="(news$ | async)?.title">
            <a *ngIf="(news$ | async)?.url" target="_blank" class="card-img-top card-news-detail__link"
              [href]="(news$ | async)?.url">
              <img [src]="(news$ | async)?.image" class="card-img-top card-news-detail__img"
                [alt]="(news$ | async)?.title">
            </a>
            <div class="card-body card-news-detail__body">
              <h5 class="card-title card-news-detail__title">{{(news$ | async)?.title}}</h5>
              <h6 class="card-title card-news-detail__title">{{(news$ | async)?.subtitle}}</h6>
              <p class="card-text card-news-detail__text" [innerHTML]="(news$ | async)?.text"></p>
              <p class="card-text card-news-detail__text"><small class="text-muted">Pubblicata il {{(news$ |
                  async)?.date| dayjs: 'DD MMMM YYYY'}}</small></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
